<template>
  <section class="gallery-section" v-if="$store.state.homeGallery && $store.state.homeGallery.length">
    <div class="gallery-section__container">
      <h2 class="gallery-section__title">Галерея</h2>
      <div class="gallery-section__slider">
        <flicking ref="flicking" :options="options" cameraTag="div" tag="div" viewportTag="div" class="gallery-section__slider__items">
          <router-link v-for="(gallery, index) in $store.state.homeGallery" :key="index" class="gallery" :to="{ name: 'photos', params: { id: gallery.id } }" :title="gallery.name" :aria-label="gallery.name">
            <img class="gallery__image" :src="gallery.img_gallery | findSource($store.state.api)" :alt="gallery.name" @error="error"/>
            <h3 class="gallery__title">{{ gallery.name }}</h3>
            <time class="gallery__date" :datetime="gallery.updated_at | robotDate">{{ gallery.updated_at | humanDate }}</time>
          </router-link>
        </flicking>
        <div class="gallery-section__slider__controls">
          <a class="gallery-section__slider__arrow" title="Скролл влево" aria-label="Скролл влево" href="javascript:void(0);" @click.prevent="$refs.flicking.prev()">
            <i class="gallery-section__slider__arrow__icon" aria-hidden="true">
              <slider-arrow-icon/>
            </i>
          </a>
          <a class="gallery-section__slider__arrow" title="Скролл вправо" aria-label="Скролл вправо" href="javascript:void(0);" @click.prevent="$refs.flicking.next()">
            <i class="gallery-section__slider__arrow__icon gallery-section__slider__arrow__icon--reversed" aria-hidden="true">
              <slider-arrow-icon/>
            </i>
          </a>
        </div>
      </div>
      <router-link :to="{ name: 'gallery' }" class="button-light button-light--inverse" title="Перейти в галерею">Перейти в галерею</router-link>
    </div>
  </section>
</template>

<script>
import SliderArrowIcon from 'components/svg/SliderArrowIcon.vue'
import { Flicking } from '@egjs/vue-flicking'

export default {
  name: 'GallerySection',
  components: { SliderArrowIcon, Flicking },
  methods: {
    error (e) {
      if (e.target.src !== '/public/img/gallery-placeholder.svg') e.target.src = '/public/img/gallery-placeholder.svg'
    }
  },
  data () {
    return {
      options: {
        hanger: 0,
        anchor: 0,
        circular: true,
        useOffset: true,
        zIndex: 1,
        gap: 32,
        moveType: {
          type: 'snap'
        }
      }
    }
  }
}
</script>
